import { render, staticRenderFns } from "./AllGames.vue?vue&type=template&id=46190094"
import script from "./AllGames.vue?vue&type=script&lang=js"
export * from "./AllGames.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports